<template>
    <div class="box"
        :class="[ loading ? 'box-loading' : '' ]"
    >
        <div class="box-header">
            <slot name="header"></slot>
            <toggle 
                v-if="hideable" 
                v-model="show" 
                :sync="true" 
                :labels="{checked: resource('Bool_Hide'), unchecked: resource('Bool_Show')}"
                :width="78"
                class="pull right" 
            />
        </div>
        <div ref="body" class="box-body">
            <div class="loading-data" v-if="loading"/>
            <slot name="body"></slot>
        </div>
        
        <!-- Only render when slot is actually filled -->
        <div class="box-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>

import $ from 'jquery';

//Components
import LoadingBox from '../../../Core/Components/Util/LoadingBox.vue';
import { ToggleButton } from 'vue-js-toggle-button';

//Mixins
import resourceMixin from '../../../Core/Util/Mixins/resources';

export default {
    name: 'bootstrap-box',
    mixins: [resourceMixin],
    components: {
        'Toggle': ToggleButton,
        LoadingBox
    },
    watch: {
        show(value) {
            if(value) {
                $(this.$refs.body).slideDown();
            } else {
                $(this.$refs.body).slideUp();
            }
        }
    },
    data() {
        return {
             show: !this.loadHidden
        };
    },
    props: {
        hideable: {
            type: Boolean,
            default: false
        },
        loadHidden: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped src="./Styles/bootstrap-box.scss">

</style>